import { Lock } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const ROWS = [
  ["recebido", "Recebido", "O pedido chegou e espera a loja aceitar", true],
  ["confirmado", "Confirmado", "A loja aceitou o pedido"],
  ["preparo", "Em preparação", "O pedido está sendo feito"],
  ["pronto", "Pronto para entrega", "Na retirada aparece como \"Esperando retirada\""],
  ["entrega", "Saiu para entrega", "Só vale para pedidos de entrega"],
  ["entregue", "Entregue", "Fecha o pedido e lança a venda no caixa", true],
];

export function OrderStepsCard({ steps, onChange }) {
  return (
    <div className="card-surface space-y-3 p-5" data-testid="order-steps-card">
      <div>
        <p className="eyebrow">Etapas do pedido</p>
        <p className="mt-1 text-sm text-muted-foreground">Desligue as etapas que você não usa. O botão de avançar no pedido pula as etapas desligadas.</p>
      </div>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {ROWS.map(([k, l, d, fixed]) => (
          <label key={k} className="flex items-center justify-between gap-3 rounded-lg border px-4 py-3 text-sm" data-testid={`order-step-${k}`}>
            <span>{l}<span className="block text-xs text-muted-foreground">{fixed ? <span className="inline-flex items-center gap-1"><Lock className="h-3 w-3" />Obrigatória</span> : d}</span></span>
            <Switch checked={fixed || steps[k] !== false} disabled={fixed} onCheckedChange={(v) => onChange({ ...steps, [k]: v })} data-testid={`order-step-switch-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
}
